<template>
  <div class="main">
    <div class="wrapper">
      <div class="navigation">
        <router-link to="/debito/dados-debito-veicular">
          <img :src="icBack" />
        </router-link>
        <span>Débito Veicular</span>
        <router-link to="/home">
          <img :src="icClose" />
        </router-link>
      </div>

      <div class="content">
        <p>
          Por favor,
          <small>Confirme seus dados.</small>
        </p>

        <div class="info border">
          <span class="badge">Lista de Débitos</span>

          <div class="list">
            <ul>
              <li><b>Nome:</b> {{ nome }}</li>
              <li><b>Documento:</b> {{ cpf }}</li>
              <li><b>Valor do débito:</b> R$ {{ totalDebitos }}</li>
            </ul>
            <div class="total bg">
              <p>Total dos débitos: <small>R$ {{ totalDebitos }}</small></p>
            </div>
          </div>
        </div>

        <a @click="avancar">
          <img :src="next" class="nextStep" />
        </a>
      </div>

      <FooterGlobal />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import icNext from '@/assets/svg/ic-next.svg'
import icClose from '@/assets/svg/ic-close.svg'
import icBack from '@/assets/svg/ic-back.svg'
import FooterGlobal from '@/components/Footer.vue'
import axios from 'axios'
import { timerToReturnToHome } from '@/helper/timer'

export default defineComponent({
  name: 'ListaDebitoVeicular',
  components: {
    FooterGlobal,
  },
  data() {
    timerToReturnToHome(40000)
    return {
      next: icNext,
      icClose: icClose,
      icBack: icBack,
      nome: '',
      cpf: '',
      phone: '',
      totalDebitos: 0,
      loading: false,
    }
  },
  created() {
    try {
      const dataResult = JSON.parse(sessionStorage.getItem('dadosPessoais') || '{}')
      const dataDebito = JSON.parse(sessionStorage.getItem('totalDebito') || '{}')

      this.cpf = dataResult.cpf || 'CPF não disponível'
      this.phone = dataResult.phone || 'Telefone não disponível'
      this.totalDebitos = dataDebito.totalDebitos || 0
      this.nome = sessionStorage.getItem('clienteNome') || 'Nome não disponível'
    } catch (e) {
      console.error('Erro ao ler sessionStorage:', e)
    }
  },
  methods: {
    async avancar() {
      this.loading = true
      try {
        await this.buscaPlanoDebitoVeicularPorEstado()
        this.$router.push('/debito/parcela-debito-veicular')
      } catch (error) {
        console.error('Erro ao tentar avançar:', error)
      } finally {
        this.loading = false
      }
    },

    async buscaPlanoDebitoVeicularPorEstado() {
      const username = process.env.VUE_APP_IPAG_API_USER
      const password = process.env.VUE_APP_IPAG_API_PASSWORD
      const url = process.env.VUE_APP_API_URL
      const basicAuth = btoa(`${username}:${password}`)
      console.log('username:', username)
      console.log('password:', password)
      console.log('url:', url)

      const clienteVeiculo = sessionStorage.getItem('clienteVeiculo')
      const totalDebitoRaw = sessionStorage.getItem('totalDebito')
      console.log('Cliente Veículo:', clienteVeiculo)
      console.log('Total Débito Raw:', totalDebitoRaw)
      const valor = totalDebitoRaw
        ? JSON.parse(totalDebitoRaw).totalDebitos
        : 0

      const dadosEnvio = {
        estado: clienteVeiculo,
        codParceiro: 2,
        valor: valor,
      }

      const response = await axios.post(`${url}/totem/tabelaDebitoVeicular.php`, dadosEnvio, {
        headers: {
          Authorization: `Basic ${basicAuth}`,
          'Content-Type': 'application/json',
        },
      })

      console.log('Resposta API nova:', response.data)

      const parcelas = Array.isArray(response.data)
        ? response.data
        : response.data?.dados || []

      if (!Array.isArray(parcelas) || parcelas.length === 0) {
        throw new Error('Nenhuma parcela retornada pela API')
      }

   
      sessionStorage.setItem('dadosParcelas', JSON.stringify(parcelas))

      sessionStorage.setItem('dadosParcelasCompleto', JSON.stringify(response.data))
    },
  },
})
</script>